<!-- svelte-ignore a11y-click-events-have-key-events -->
<script>
	import { TwitchIcon, VideoIcon, ChevronDownIcon, ChevronRightIcon } from 'svelte-feather-icons'
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	var questions = [
		{
			q: "What is FGCards?",
			a: "FGCards is a fighting-game themed digital trading card game for Discord. Players can collect cards, build decks, challenge others to duels, and trade with both players and merchants."
		},
		{
			q: "How do I Play?",
			a: "Join the <a href='https://discord.gg/vA677QqXBz'>FGCards</a> Discord server.  Begin by using /bdrop to get your first set of 3 cards. You can then view your collection with /binv and start building your deck with /bbuild-deck"
		},
		{
			q: "How do I get more cards?",
			a: `
				<ul>
				<li>Use /bdrop to drop cards.  Check your cooldowns with /bcd.</li>
				<li>Use /bmerchant to buy cards or card-packs</li>
				<li>Claim daily rewards with /bdaily</li>
				<li>Vote at Top.gg and claim rewards with /bivoted</li>
				<li>Win duels against other players or bots</li>
				<li>Trade with other players using /btrade</li></ul>
			`
		},
		{
			q: "How does PVP & Dueling work?",
			a: `
			PVP in FGCards is a strategic card battle system where players face off using decks of 4 unique cards:\n
			<br/>
			<b>Core Mechanics:</b>

			Each card has Attack Power (AP) based on its rarity and condition
			Cards have two weapon types to choose from: Heavy📕, Quick📗, or Ranged📘
			
			<ul>
				<li>Heavy📕 beats Quick📗</li>
				<li>Ranged📘 beats Heavy📕</li>
				<li>Quick📗 beats Ranged📘</li>
			</ul>

			When same weapons clash, higher AP wins. <br/>

			<b>Battle Flow:</b>

			Both players start with their 4-card deck
			<ul>
				<li>Players have 60 seconds to pick a card</li>
				<li>Players choose which weapon type to use</li>
			</ul>

			Winning player keeps their card, losing card is removed. Battle continues until one player loses all cards
			`
		},
		{
			q: "How can I play against Bots? (Limited Edition Rewards)",
			a: `
				<ul>
					<li>/bduel-bot - Practice against AI (different difficulty levels)</li>
					<li>Use the (event) paramter when dueling bots for a chance at limited rewards!</li>
				</ul>
			`
		},
		{
			q: "How can I vote for FGCards at TopGG",
			a: "Navigate to: <a href='https://top.gg/bot/1217169611284549776'>TopGG</a> and vote!  Then you can claim a reward by using the !bivoted command."
		},
		{
			q: "What are some important commands I should know?",
			a: `
				<ul>
					<li>/binv - View your cards and coins</li>
					<li>/bdrop - Get new cards</li>
					<li>/bbuild-deck - Create a deck (requires 4 cards)</li>
					<li>/bduel - Challenge other players</li>
					<li>/bduel-bot - Practice against AI (different difficulty levels)</li>
					<li>/bshow [cardid] - View details of a specific card</li>
					<li>/bscore - Top 10 Rankings. Most Coins, Most Legendaries, etc</li>
				</ul>
			`
		},
		{
			q: "What are card conditions and how can I improve them?",
			a: "Cards come in different conditions: poor, good, near mint, and mint. You can upgrade a card's condition using /bupgrade by spending coins.  Mint condition cards can be framed by a frame from the shop!"
		},
		{
			q: "How does trading work?",
			a: "Player-to-player trading using /btrade - you can trade cards for cards or coins. Merchant trading using /bmerchant-trade - trade cards with the NPC merchant."
		},
		{
			q: "What happens if I get cards I don't want?",
			a: "You can burn unwanted cards for coins using /bburn [cardid]. The amount of coins received depends on the card's rarity and condition."
		},
		
	];

	onMount(() => {
		console.log($io)
		window.io = $io;
	});
	
</script>

<div class='con-page'>
	<div class='con-dash'>
		
		<div class='landing-header y'>
			How to Play?
		</div>

		<div style='margin: 70px 0px;'>

			{#each questions as q}
				<div class='con-question' class:active={false} on:click={(e)=>{ e.currentTarget.classList.toggle('active'); }} >
					<div class='div-question y'>
						<div class='con-icon-down'><ChevronDownIcon size='33' /></div>
						<div class='con-icon-right'><ChevronRightIcon size='33' /></div>
						<div>{q.q}</div>
					</div>
					<div class='div-answer'> {@html q.a} </div>
				</div>
			{/each}

		</div>

		<hr />

	</div>
</div>

<style type="text/less">
	.con-page{
		display:grid;
	}
	.con-dash{
		display:grid;
		justify-self:center;
		width: 100%;
		max-width:var(--mwidth);
		//margin-top:30px;
		margin-top:10px;
		padding:30px;
	}

	.con-question{
		margin-bottom:20px;

		.con-icon-down{ display:none; }
		.con-icon-right{ display:block; }

		.div-answer{
			display:none;
			font-family: Open Sans, sans-serif;
			font-weight:600;
			line-height:1.5em;
		}

		&.active{
			.con-icon-down{ display:block; }
			.con-icon-right{ display:none; }
			.div-answer{
				margin:20px;
				display:block;
			}
		}


	}

	.div-question{
		display:grid;
		grid-template-columns:min-content auto;
		align-items:center;
		font-size:1.5em;
		gap:5px;



		&:hover{
			text-decoration: underline;;
			cursor:pointer;
		}
	}

	.landing-header{
		
		text-align:center;
		font-weight:bold;
		font-size:3em;
	}

</style>